/*!
 * Edible Growth — EGModals
 * Premium ingredient, benefit, and science popup system.
 * Defines window.EGModals used site-wide by product and education pages.
 */
(function () {
  'use strict';

  /* ── Inject premium CSS for molecule + benefit panels ─────────── */
  var s = document.createElement('style');
  s.id = 'eg-modals-premium';
  s.textContent =

    /* ── Backdrop ── */
    '#eg-modal-molecule,#eg-modal-benefit{' +
      'background:rgba(0,0,0,0.76) !important;' +
      'backdrop-filter:blur(14px) !important;' +
      '-webkit-backdrop-filter:blur(14px) !important;' +
    '}' +

    /* ── Molecule panel ── */
    '#eg-modal-molecule-panel{' +
      'background:rgba(7,10,18,0.94) !important;' +
      'backdrop-filter:blur(22px) !important;' +
      '-webkit-backdrop-filter:blur(22px) !important;' +
      'border:1px solid rgba(255,255,255,0.09) !important;' +
      'border-radius:1.5rem !important;' +
      'padding:0 !important;' +
      'max-width:34rem !important;' +
      'overflow:hidden;' +
    '}' +

    /* ── Benefit panel (matches the Ingredient Knowledge Card shell) ── */
    '#eg-modal-benefit-panel{' +
      'background:rgba(7,10,18,0.95) !important;' +
      'backdrop-filter:blur(22px) !important;' +
      '-webkit-backdrop-filter:blur(22px) !important;' +
      'border:1px solid rgba(255,255,255,0.09) !important;' +
      'border-radius:1.5rem !important;' +
      'padding:0 !important;' +
      'max-width:38rem !important;' +
      'overflow:hidden auto;' +
    '}' +

    /* ── Science panel inner padding ── */
    '#eg-modal-science-panel{padding:0 !important;}' +

    /* ── Entrance animation ── */
    '#eg-modal-molecule .eg-modal-panel,' +
    '#eg-modal-benefit .eg-modal-panel,' +
    '#eg-modal-science .eg-modal-panel{' +
      'transform:scale(0.96) translateY(14px);' +
      'transition:transform 0.44s cubic-bezier(0.16,1,0.3,1),opacity 0.32s ease;' +
    '}' +
    '#eg-modal-molecule.is-open .eg-modal-panel,' +
    '#eg-modal-benefit.is-open .eg-modal-panel,' +
    '#eg-modal-science.is-open .eg-modal-panel{transform:scale(1) translateY(0);}' +

    /* ── Inner wrapper ── */
    '.egm-inner{padding:1.75rem;position:relative;}' +

    /* ── Close button ── */
    '.egm-close{' +
      'position:absolute;top:1.1rem;right:1.1rem;' +
      'width:2.25rem;height:2.25rem;' +
      'display:flex;align-items:center;justify-content:center;' +
      'background:rgba(255,255,255,0.07);' +
      'border:1px solid rgba(255,255,255,0.11);' +
      'border-radius:9999px;' +
      'color:rgba(255,255,255,0.55);' +
      'cursor:pointer;' +
      'transition:background 0.2s,color 0.2s,box-shadow 0.2s;' +
      'z-index:3;flex-shrink:0;' +
    '}' +
    '.egm-close:hover{' +
      'background:rgba(255,255,255,0.13);' +
      'color:#fff;' +
      'box-shadow:0 0 12px rgba(255,255,255,0.10);' +
    '}' +


    /* ── Header ── */
    '.egm-header{' +
      'display:flex;align-items:center;gap:0.75rem;' +
      'margin-bottom:1rem;padding-right:2.5rem;' +
    '}' +
    '.egm-dot{' +
      'width:0.8rem;height:0.8rem;border-radius:9999px;flex-shrink:0;' +
    '}' +
    '.egm-title{' +
      'font-size:1.45rem;font-weight:800;color:#fff;' +
      'line-height:1.2;margin:0;letter-spacing:-0.01em;' +
    '}' +

    /* ── Body copy ── */
    '.egm-desc{' +
      'font-size:0.875rem;color:rgba(255,255,255,0.65);' +
      'line-height:1.68;margin:0 0 1.2rem;' +
    '}' +

    /* ── WIIFM card ── */
    '.egm-wiifm{' +
      'background:rgba(255,255,255,0.04);' +
      'border:1px solid rgba(255,255,255,0.07);' +
      'border-left:3px solid var(--mc,rgba(96,165,250,0.85));' +
      'border-radius:0.75rem;' +
      'padding:0.875rem 1rem;' +
    '}' +
    '.egm-wiifm-label{' +
      'font-size:0.625rem;font-weight:900;letter-spacing:0.13em;' +
      'text-transform:uppercase;' +
      'color:var(--mc,rgba(96,165,250,0.9));' +
      'margin-bottom:0.45rem;' +
    '}' +
    '.egm-wiifm-text{' +
      'font-size:0.875rem;color:rgba(255,255,255,0.78);' +
      'line-height:1.62;margin:0;' +
    '}' +

    /* ── Science modal content ── */
    '.egm-sci-hd{' +
      'border-bottom:1px solid rgba(255,255,255,0.08);' +
      'padding-bottom:0.875rem;margin-bottom:1rem;' +
      'padding-right:2.5rem;' +
    '}' +
    '.egm-sci-title{' +
      'font-size:1.35rem;font-weight:800;color:#fff;' +
      'margin:0;line-height:1.25;' +
    '}' +
    '.egm-sci-body{' +
      'font-size:0.9rem;color:rgba(255,255,255,0.70);line-height:1.72;' +
    '}';

  document.head.appendChild(s);

  /* ── Ingredient Knowledge Card styling (Module-2 visual language) ─ */
  var sk = document.createElement('style');
  sk.id = 'eg-modal-ingredient-premium';
  sk.textContent =
    '#eg-modal-ingredient{' +
      'background:rgba(0,0,0,0.78) !important;' +
      'backdrop-filter:blur(14px) !important;' +
      '-webkit-backdrop-filter:blur(14px) !important;' +
    '}' +
    '#eg-modal-ingredient-panel{' +
      'background:rgba(7,10,18,0.95) !important;' +
      'backdrop-filter:blur(22px) !important;' +
      '-webkit-backdrop-filter:blur(22px) !important;' +
      'border:1px solid rgba(255,255,255,0.09) !important;' +
      'border-radius:1.5rem !important;' +
      'padding:0 !important;' +
      'max-width:60rem !important;' +
      'overflow:hidden auto;' +
    '}' +
    '#eg-modal-ingredient .eg-modal-panel{' +
      'transform:scale(0.96) translateY(14px);' +
      'transition:transform 0.44s cubic-bezier(0.16,1,0.3,1),opacity 0.32s ease;' +
    '}' +
    '#eg-modal-ingredient.is-open .eg-modal-panel{transform:scale(1) translateY(0);}' +

    /* ── Two-column grid ── */
    '.egk-grid{position:relative;display:grid;grid-template-columns:1fr;}' +
    '@media (min-width:820px){.egk-grid{grid-template-columns:1.55fr 1fr;}}' +

    /* ── Visual (image) column ── */
    '.egk-visual{' +
      'position:relative;min-height:13rem;overflow:hidden;order:-1;' +
      'border-radius:1.5rem 1.5rem 0 0;' +
      'background:radial-gradient(ellipse 92% 80% at 50% 46%,var(--egk-glow,rgba(96,165,250,0.22)) 0%,rgba(7,10,18,1) 72%);' +
    '}' +
    '@media (min-width:820px){.egk-visual{order:0;min-height:100%;border-radius:0 1.5rem 1.5rem 0;border-left:1px solid rgba(255,255,255,0.06);}}' +
    /* Physical-photo visual — premium full-bleed with vignette fade (Task 3) */
    '.egk-visual-img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;padding:0;}' +
    '.egk-visual-veil{position:absolute;inset:0;pointer-events:none;}' +

    /* ── Cannabinoid molecule visual — large faint centered artwork + glow (Task 4) ── */
    '.egk-visual--mol{background:radial-gradient(circle at 50% 48%,var(--egk-glow,rgba(96,165,250,0.42)) 0%,transparent 60%),radial-gradient(ellipse 96% 88% at 50% 46%,rgba(255,255,255,0.03) 0%,rgba(7,10,18,1) 74%);}' +
    '.egk-visual-mol{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;padding:1.1rem;transform:scale(1.26);opacity:0.2;filter:drop-shadow(0 0 16px var(--mc,#60a5fa));pointer-events:none;}' +
    '@media (min-width:820px){.egk-visual-mol{transform:scale(1.34);}}' +

    /* ── Prev / Next navigation arrows (Task 1) ── */
    '.egk-nav{position:absolute;top:50%;transform:translateY(-50%);width:2.9rem;height:2.9rem;border-radius:9999px;display:flex;align-items:center;justify-content:center;background:rgba(10,14,24,0.72);border:1px solid rgba(255,255,255,0.14);color:rgba(255,255,255,0.85);cursor:pointer;z-index:6;-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);transition:background 0.2s,color 0.2s,box-shadow 0.2s;}' +
    '.egk-nav:hover{background:rgba(22,28,44,0.92);color:#fff;box-shadow:0 6px 18px rgba(0,0,0,0.4);}' +
    '.egk-nav:active{background:rgba(30,38,58,0.95);}' +
    '.egk-nav svg{width:22px;height:22px;}' +
    '.egk-nav-prev{left:0.7rem;}' +
    '.egk-nav-next{right:0.7rem;}' +
    '@media (min-width:820px){.egk-grid.egk-has-nav .egk-main{padding-left:3.9rem;}}' +

    /* ── Fade content swap for prev/next (Task 2) ── */
    '.egk-grid{opacity:1;transition:opacity 0.28s ease;}' +
    '.egk-grid.egk-enter{opacity:0;}' +

    /* ── Main (content) column ── */
    '.egk-main{padding:2rem;position:relative;min-width:0;}' +
    '@media (min-width:820px){.egk-main{padding:2.25rem 2.25rem 2rem;}}' +

    /* Category badge */
    '.egk-badge{' +
      'display:inline-flex;align-items:center;gap:0.4rem;' +
      'font-size:0.62rem;font-weight:800;letter-spacing:0.14em;text-transform:uppercase;' +
      'color:var(--mc,#60a5fa);' +
      'border:1px solid var(--mc,rgba(96,165,250,0.4));' +
      'background:rgba(255,255,255,0.03);' +
      'padding:0.32rem 0.72rem;border-radius:9999px;margin-bottom:0.9rem;' +
    '}' +
    '.egk-badge-dot{width:0.45rem;height:0.45rem;border-radius:9999px;flex-shrink:0;}' +

    /* Title — Module-2 gradient heading */
    '.egk-title{' +
      'font-size:1.9rem;font-weight:800;line-height:1.1;margin:0;letter-spacing:-0.015em;' +
      'color:#fff;' +
      'background:linear-gradient(to right,var(--mc,#60a5fa),#fff 72%);' +
      '-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;' +
    '}' +
    '@media (min-width:820px){.egk-title{font-size:2.25rem;}}' +
    '.egk-summary{font-size:0.95rem;color:rgba(255,255,255,0.6);line-height:1.55;margin:0.7rem 0 0;}' +

    /* ── Three horizontal topic cards ── */
    '.egk-cards{display:flex;flex-direction:column;gap:0.75rem;margin-top:1.4rem;}' +
    '.egk-card{' +
      'position:relative;display:flex;align-items:flex-start;gap:0.9rem;' +
      'padding:1rem 1.05rem;border-radius:0.85rem;overflow:hidden;' +
      'background:rgba(255,255,255,0.035);border:1px solid rgba(255,255,255,0.07);' +
      'transition:background 0.25s,border-color 0.25s,box-shadow 0.25s;' +
    '}' +
    '.egk-card:hover{' +
      'background:rgba(255,255,255,0.07);' +
      'border-color:rgba(96,165,250,0.28);' +
      'border-color:color-mix(in srgb,var(--mc,#60a5fa) 38%,transparent);' +
      'box-shadow:0 6px 22px rgba(0,0,0,0.28);' +
    '}' +
    '.egk-card-ic{' +
      'flex-shrink:0;width:2.5rem;height:2.5rem;border-radius:9999px;' +
      'display:flex;align-items:center;justify-content:center;' +
      'color:var(--mc,#60a5fa);' +
      'background:rgba(96,165,250,0.12);' +
      'background:color-mix(in srgb,var(--mc,#60a5fa) 14%,transparent);' +
      'border:1px solid rgba(96,165,250,0.28);' +
      'border:1px solid color-mix(in srgb,var(--mc,#60a5fa) 30%,transparent);' +
      'transition:transform 0.25s;' +
    '}' +
    '.egk-card:hover .egk-card-ic{transform:scale(1.07);}' +
    '.egk-card-body{flex:1;min-width:0;}' +
    '.egk-card-h{font-size:0.95rem;font-weight:700;color:#fff;margin:0 0 0.3rem;line-height:1.2;}' +
    '.egk-card-t{font-size:0.85rem;color:rgba(255,255,255,0.68);line-height:1.55;margin:0;}' +
    '.egk-card-arrow{' +
      'flex-shrink:0;align-self:center;color:#4b5563;' +
      'transition:color 0.2s,transform 0.2s;' +
    '}' +
    '.egk-card:hover .egk-card-arrow{color:var(--mc,#60a5fa);transform:translateX(3px);}' +

    /* WIIFM mini-list inside its card */
    '.egk-mini-list{list-style:none;margin:0.15rem 0 0;padding:0;display:flex;flex-direction:column;gap:0.4rem;}' +
    '.egk-mini-item{display:flex;align-items:flex-start;gap:0.5rem;font-size:0.85rem;color:rgba(255,255,255,0.72);line-height:1.5;}' +
    '.egk-mini-dot{flex-shrink:0;width:0.4rem;height:0.4rem;border-radius:9999px;margin-top:0.5rem;background:var(--mc,#60a5fa);}' +

    /* ── Pairs Well With chips ── */
    '.egk-pairs{margin-top:1.25rem;}' +
    '.egk-pairs-label{' +
      'font-size:0.6rem;font-weight:900;letter-spacing:0.14em;text-transform:uppercase;' +
      'color:rgba(255,255,255,0.4);margin-bottom:0.6rem;' +
    '}' +
    '.egk-pairs-list{display:flex;flex-wrap:wrap;gap:0.45rem;}' +
    /* Chips match the homepage ingredient pills: glass, no dot/arrow,
       hover lights up in the ingredient accent (--ec) with no width shift. */
    '.egk-pair-chip{' +
      'display:inline-flex;align-items:center;' +
      'font-size:0.78rem;font-weight:600;' +
      'padding:0.42rem 0.85rem;border-radius:9999px;' +
      'background:rgba(255,255,255,0.05);' +
      'border:1px solid rgba(255,255,255,0.1);' +
      'color:rgba(255,255,255,0.82);cursor:pointer;' +
      'transition:color 0.2s,background 0.2s,border-color 0.2s,transform 0.2s,box-shadow 0.2s;' +
    '}' +
    '.egk-pair-chip:hover{' +
      'color:var(--ec,#93c5fd);' +
      'background:rgba(96,165,250,0.12);' +
      'background:color-mix(in srgb,var(--ec,#60a5fa) 14%,rgba(255,255,255,0.05));' +
      'border-color:rgba(96,165,250,0.45);' +
      'border-color:color-mix(in srgb,var(--ec,#60a5fa) 45%,transparent);' +
      'transform:translateY(-2px);' +
      'box-shadow:0 6px 16px rgba(0,0,0,0.3),0 0 14px color-mix(in srgb,var(--ec,#60a5fa) 35%,transparent),inset 0 0 12px color-mix(in srgb,var(--ec,#60a5fa) 18%,transparent);' +
    '}' +

    /* ── Benefit popup — same UI system as the Knowledge Card ── */
    '.egb-inner{padding:1.9rem;position:relative;}' +
    '.egb-head{display:flex;align-items:center;gap:0.85rem;margin-bottom:1.1rem;padding-right:2.5rem;}' +
    '.egb-icon{' +
      'flex-shrink:0;width:2.75rem;height:2.75rem;border-radius:9999px;' +
      'display:flex;align-items:center;justify-content:center;' +
      'color:var(--mc,#60a5fa);' +
      'background:rgba(96,165,250,0.12);' +
      'background:color-mix(in srgb,var(--mc,#60a5fa) 14%,transparent);' +
      'border:1px solid rgba(96,165,250,0.30);' +
      'border:1px solid color-mix(in srgb,var(--mc,#60a5fa) 32%,transparent);' +
    '}' +
    '.egb-title{' +
      'font-size:1.5rem;font-weight:800;line-height:1.15;margin:0;letter-spacing:-0.01em;' +
      'color:#fff;' +
      'background:linear-gradient(to right,var(--mc,#60a5fa),#fff 75%);' +
      '-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;' +
    '}' +
    '@media (min-width:600px){.egb-title{font-size:1.7rem;}}' +
    '.egb-inner .egk-cards{margin-top:0;}' +

    /* ── Mobile / Android optimisation, target 360–430px (Task 7) ── */
    '@media (max-width:600px){' +
      /* Modal fits the viewport: ~94vw wide, ~90vh tall, internal scroll, no h-scroll */
      '#eg-modal-ingredient-panel,#eg-modal-benefit-panel,#eg-modal-molecule-panel,#eg-modal-science-panel{max-width:94vw !important;max-height:90vh !important;border-radius:1.25rem !important;}' +
      '#eg-modal-ingredient-panel{width:94vw !important;}' +
      '.egk-main{padding:1.5rem 1.4rem 1.6rem;min-width:0;}' +
      '.egk-grid.egk-has-nav .egk-main{padding-left:1.4rem;}' +   /* arrows sit over image, not text */
      '.egk-visual{min-height:11rem;height:11rem;}' +            /* fixed height → arrows centre cleanly */
      '.egk-visual-img{padding:0;}' +
      '.egk-visual-mol{transform:scale(1.16);padding:0.9rem;}' +
      '.egk-title{font-size:1.5rem;}' +
      '.egk-summary{font-size:0.9rem;}' +
      '.egk-cards{margin-top:1.1rem;}' +
      '.egk-card{padding:0.9rem 0.95rem;gap:0.75rem;}' +
      '.egk-card-ic{width:2.4rem;height:2.4rem;}' +
      '.egk-card-h{font-size:0.98rem;}' +
      '.egk-card-t,.egk-mini-item{font-size:0.9rem;}' +
      '.egb-inner{padding:1.4rem;}' +
      '.egm-close{top:0.7rem;right:0.7rem;width:2.5rem;height:2.5rem;}' +   /* 40px tap target */
      '.egk-pairs-list{gap:0.45rem;}' +
      '.egk-pair-chip{padding:0.5rem 0.9rem;font-size:0.82rem;}' +          /* larger tap target */
      /* Prev/next centred over the top image band — never over text */
      '.egk-nav{width:2.9rem;height:2.9rem;top:5.5rem;}' +
      '.egk-nav-prev{left:0.6rem;}' +
      '.egk-nav-next{right:0.6rem;}' +
    '}';

  document.head.appendChild(sk);

  /* ── Helpers ──────────────────────────────────────────────────── */
  var CLOSE_BTN =
    '<button class="egm-close" aria-label="Close">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"' +
    ' fill="none" stroke="currentColor" stroke-width="2.5"' +
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<line x1="18" y1="6" x2="6" y2="18"/>' +
    '<line x1="6" y1="6" x2="18" y2="18"/>' +
    '</svg></button>';

  function esc(v) {
    return String(v || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function hexToRgba(hex, a) {
    if (!hex || hex.charAt(0) !== '#') return 'rgba(96,165,250,' + a + ')';
    var h = hex.replace('#', '');
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    return 'rgba(' + parseInt(h.slice(0,2),16) + ',' +
                     parseInt(h.slice(2,4),16) + ',' +
                     parseInt(h.slice(4,6),16) + ',' + a + ')';
  }

  /* ── Content renderers ────────────────────────────────────────── */
  function moleculeHTML(d) {
    var img = '';
    if (d.imageUrl) {
      var bg   = 'rgba(7,10,18,1)';
      var glow = hexToRgba(d.color || '#60a5fa', 0.24);
      /* Dark overlay dissolve — fades image into container bg from all edges.
         No CSS mask needed: the overlay matches the container background exactly,
         creating a seamless blend regardless of image shape or aspect ratio. */
      var overlayBg =
        'radial-gradient(ellipse 76% 78% at 50% 54%,' +
        'transparent 30%,rgba(7,10,18,0.44) 55%,rgba(7,10,18,0.87) 75%,rgba(7,10,18,1) 100%),' +
        'linear-gradient(to bottom,rgba(7,10,18,1) 0%,transparent 14%,transparent 84%,rgba(7,10,18,1) 100%)';
      img =
        '<div style="position:relative;width:100%;height:13rem;overflow:hidden;' +
        'border-radius:1.5rem 1.5rem 0 0;' +
        'background:radial-gradient(ellipse 96% 88% at 50% 54%,' + glow + ' 0%,' + bg + ' 72%);">' +
        '<img src="' + esc(d.imageUrl) + '" alt="' + esc(d.imageAlt || d.name) + '"' +
        ' decoding="async"' +
        ' style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain;">' +
        '<div style="position:absolute;inset:0;pointer-events:none;background:' + overlayBg + '"></div>' +
        '</div>';
    }
    var dot = d.color
      ? '<span class="egm-dot" style="background:' + esc(d.color) +
        ';box-shadow:0 0 8px ' + esc(d.color) + '60"></span>'
      : '';
    var wiifm = d.wiifm
      ? '<div class="egm-wiifm">' +
        '<div class="egm-wiifm-label">What\'s In It For Me?</div>' +
        '<p class="egm-wiifm-text">' + esc(d.wiifm) + '</p>' +
        '</div>'
      : '';
    return img +
      '<div class="egm-inner">' + CLOSE_BTN +
      '<div class="egm-header">' + dot +
      '<h2 class="egm-title">' + esc(d.name) + '</h2>' +
      '</div>' +
      '<p class="egm-desc">' + esc(d.description) + '</p>' +
      wiifm + '</div>';
  }

  /* ── Shared premium line-icon set (24x24, currentColor) ───────── */
  var EG_ICONS = {
    moon:      '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>',
    brain:     '<path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"/><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"/>',
    recovery:  '<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/>',
    droplet:   '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>',
    zap:       '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>',
    target:    '<circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>',
    smile:     '<circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/>',
    heart:     '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/>',
    crosshair: '<circle cx="12" cy="12" r="10"/><line x1="22" y1="12" x2="18" y2="12"/><line x1="6" y1="12" x2="2" y2="12"/><line x1="12" y1="6" x2="12" y2="2"/><line x1="12" y1="22" x2="12" y2="18"/>',
    shield:    '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>',
    eye:       '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>',
    link:      '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>',
    activity:  '<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>',
    info:      '<circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>'
  };

  function egIconSvg(name, size) {
    var inner = EG_ICONS[name] || EG_ICONS.activity;
    size = size || 20;
    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '"' +
      ' viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"' +
      ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + inner + '</svg>';
  }

  /* Per-benefit accent colors — color psychology, kept premium & muted to fit
     the dark-luxury theme. Keyed by data-benefit-name. Drives the shared --mc
     token, which recolors the header gradient, large icon, section icons and
     bullets in one place. Unlisted names fall back to the default blue. */
  var BENEFIT_COLORS = {
    'Improves Blood Flow':                             '#d63a54', /* crimson — circulation */
    'Reduced Soreness':                                '#f59e0b', /* amber — recovery */
    'Enhanced Focus':                                  '#3b82f6', /* electric blue — focus */
    'Sharper Focus & Clarity':                         '#22b8c9', /* cyan — precision */
    'Faster Neural Response':                          '#4aa8f0', /* bright sky — reaction speed */
    'Delayed Eye & Mental Fatigue':                    '#2bb6a8', /* teal — sustained clarity */
    'Boosted Mood':                                    '#e0b23a', /* gold — dopamine, positivity */
    'Sustained Energy':                                '#9bb63f', /* lime — endurance, stamina */
    'Calm Under Pressure':                             '#b3a4e0', /* lavender — stress resilience */
    'Nighttime Recovery & Whole-Body Repair':          '#10b981', /* emerald — repair */
    'Deeper Restorative Sleep':                        '#8b5cf6', /* purple — deep sleep */
    'Calm the Mind & Ease Into Sleep':                 '#6366f1', /* indigo — calm, nighttime */
    'Bladder Support & Fewer Nighttime Interruptions': '#5aa2c8'  /* calm blue — nighttime comfort */
  };

  function benefitHTML(d) {
    var ingredients = Array.isArray(d.ingredients) ? d.ingredients : [];
    var cards =
      egkCard('activity', 'What It Does',  d.desc) +
      egkCard('link',     'Why It Works',  d.synergy);

    return '<div class="egb-inner">' + CLOSE_BTN +
      '<div class="egb-head">' +
      '<span class="egb-icon">' + egIconSvg(d.icon, 22) + '</span>' +
      '<h2 class="egb-title">' + esc(d.name) + '</h2>' +
      '</div>' +
      '<div class="egk-cards">' + cards + '</div>' +
      egkChipsBlock('Key Ingredients', ingredients) +
      '</div>';
  }

  function scienceHTML(d) {
    var borderColor = d.borderColor || 'rgba(96,165,250,0.7)';
    return '<div class="egm-inner">' + CLOSE_BTN +
      '<div class="egm-sci-hd" style="border-left:3px solid ' + esc(borderColor) +
      ';padding-left:0.875rem">' +
      '<h2 class="egm-sci-title">' + esc(d.title) + '</h2>' +
      '</div>' +
      '<p class="egm-sci-body">' + esc(d.body) + '</p>' +
      '</div>';
  }

  /* ── Ingredient Knowledge Card ────────────────────────────────── */
  var EGK_ARROW =
    '<svg class="egk-card-arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"' +
    ' fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';

  /* Prev / Next chevrons for ingredient navigation */
  function chevron(dir) {
    var pts = dir < 0 ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"' +
      ' stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="' + pts + '"/></svg>';
  }
  var EGK_NAV =
    '<button type="button" class="egk-nav egk-nav-prev" aria-label="Previous ingredient">' + chevron(-1) + '</button>' +
    '<button type="button" class="egk-nav egk-nav-next" aria-label="Next ingredient">' + chevron(1) + '</button>';

  /* Card body: paragraph for strings, mini bullet list for arrays */
  function egkBody(content) {
    if (Array.isArray(content)) {
      var rows = content.map(function (t) {
        return '<li class="egk-mini-item"><span class="egk-mini-dot"></span><span>' + esc(t) + '</span></li>';
      }).join('');
      return '<ul class="egk-mini-list">' + rows + '</ul>';
    }
    return '<p class="egk-card-t">' + esc(content) + '</p>';
  }

  function egkCard(iconName, heading, content) {
    if (!content || (Array.isArray(content) && !content.length)) return '';
    return '<div class="egk-card"><span class="egk-card-ic">' + egIconSvg(iconName, 19) + '</span>' +
      '<div class="egk-card-body">' +
      '<h3 class="egk-card-h">' + esc(heading) + '</h3>' +
      egkBody(content) +
      '</div>' + EGK_ARROW + '</div>';
  }

  /* Display-name cleaner: strips the internal product suffix (e.g. _Sleep)
     and the leading "Organic " label that we don't want shown to customers.
     Underlying ingredient keys are unchanged. */
  function egCleanName(s) {
    return String(s || '').replace(/_[A-Za-z]+$/, '').replace(/^Organic\s+/i, '');
  }

  /* Clickable ingredient chip (used by Pairs Well With + benefit Key Ingredients).
     Carries --ec accent so hover lights up in the ingredient's color. */
  function egkChip(k) {
    var e    = (window.EG_INGREDIENTS || {})[k] || {};
    var disp = egCleanName(e.display || k);
    var col  = e.color || '#60a5fa';
    return '<button type="button" class="egk-pair-chip" data-ing-key="' + esc(k) +
      '" style="--ec:' + esc(col) + '">' + esc(disp) + '</button>';
  }

  function egkChipsBlock(label, keys) {
    var list = keys;
    if (typeof list === 'string') list = list.split('|');
    list = (list || []).filter(Boolean);
    if (!list.length) return '';
    return '<div class="egk-pairs"><div class="egk-pairs-label">' + esc(label) + '</div>' +
      '<div class="egk-pairs-list">' + list.map(egkChip).join('') + '</div></div>';
  }

  /* Cannabinoids: molecule rendered as large, faint, centred artwork with a
     coloured glow — kept in its own function so the photo path stays clean. */
  function moleculeVisualHTML(d) {
    var mglow = hexToRgba(d.color || '#60a5fa', 0.42);
    var img = d.imageUrl
      ? '<img class="egk-visual-mol" src="' + esc(d.imageUrl) + '" alt="' + esc(d.imageAlt || d.name) + '" decoding="async" loading="eager">'
      : '';
    return '<div class="egk-visual egk-visual--mol" style="--egk-glow:' + mglow +
      ';--mc:' + esc(d.color || '#60a5fa') + '">' + img + '</div>';
  }

  function ingredientVisualHTML(d) {
    if (d.isMolecule) return moleculeVisualHTML(d);

    var glow = hexToRgba(d.color || '#60a5fa', 0.24);
    var overlayBg =
      'radial-gradient(ellipse 82% 82% at 50% 50%,' +
      'transparent 42%,rgba(7,10,18,0.4) 66%,rgba(7,10,18,0.92) 88%,rgba(7,10,18,1) 100%)';
    /* Optional per-ingredient focal point / zoom. Empty unless the entry sets
       imagePosition / imageScale, so every existing ingredient is unchanged. */
    var imgStyle = '';
    if (d.imagePosition) imgStyle += 'object-position:' + esc(d.imagePosition) + ';';
    if (d.imageScale)    imgStyle += 'transform:scale(' + esc(d.imageScale) + ');';
    var imgStyleAttr = imgStyle ? ' style="' + imgStyle + '"' : '';
    var inner = d.imageUrl
      ? '<img class="egk-visual-img" src="' + esc(d.imageUrl) + '" alt="' + esc(d.imageAlt || d.name) + '" decoding="async" loading="eager"' + imgStyleAttr + '>' +
        '<div class="egk-visual-veil" style="background:' + overlayBg + '"></div>'
      : '';
    return '<div class="egk-visual" style="--egk-glow:' + glow + '">' + inner + '</div>';
  }

  function ingredientHTML(d) {
    var badge = '<span class="egk-badge">' +
      '<span class="egk-badge-dot" style="background:' + esc(d.color || '#60a5fa') + '"></span>' +
      esc(d.category || 'Ingredient') + '</span>';

    /* Suppress the summary when it just repeats the "What Is It?" copy */
    var showSummary = d.summary &&
      (!d.whatIsIt || d.whatIsIt.indexOf(d.summary) !== 0);
    var summary = showSummary ? '<p class="egk-summary">' + esc(d.summary) + '</p>' : '';

    var cards =
      egkCard('info',   'What Is It?',          d.whatIsIt) +
      egkCard('target', 'Why We Use It',        d.why) +
      egkCard('zap',    "What's In It For Me?",  d.wiifm);

    var navHtml = d._hasNav ? EGK_NAV : '';
    var gridCls = d._hasNav ? 'egk-grid egk-has-nav' : 'egk-grid';
    return '<div class="' + gridCls + '">' + CLOSE_BTN + navHtml +
      '<div class="egk-main">' + badge +
      '<h2 class="egk-title">' + esc(d.name) + '</h2>' + summary +
      '<div class="egk-cards">' + cards + '</div>' +
      egkChipsBlock('Pairs Well With', d.pairs) +
      '</div>' +
      ingredientVisualHTML(d) +
      '</div>';
  }

  /* ── EGModals ─────────────────────────────────────────────────── */
  /* Visible, tabbable elements inside a container — powers the modal focus trap. */
  function egFocusable(container) {
    if (!container) return [];
    var sel = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(container.querySelectorAll(sel), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  window.EGModals = {
    _kb: null,
    _nav: null,
    _pendingNav: null,
    _scrollLock: { active: false, y: 0 },
    _prevFocus: null,
    _triggerEl: null,

    /* Lock background scroll without losing position (Android Chrome + iOS Safari).
       position:fixed keeps the page behind the modal from scrolling or overscroll-
       bleeding; the modal panel keeps its own internal scroll. Re-entrant so chaining
       modals (benefit -> ingredient) never re-saves the position or double-restores. */
    _lockScroll: function () {
      if (this._scrollLock.active) return;
      var y = window.scrollY || window.pageYOffset || 0;
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      this._scrollLock = { active: true, y: y };
      var b = document.body;
      b.style.position = 'fixed';
      b.style.top = (-y) + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
      b.style.overflow = 'hidden';
      if (sbw > 0) b.style.paddingRight = sbw + 'px';   /* avoid desktop scrollbar shift */
    },

    _unlockScroll: function () {
      if (!this._scrollLock.active) return;
      var y = this._scrollLock.y;
      this._scrollLock = { active: false, y: 0 };
      var html = document.documentElement, b = document.body;
      /* base.css sets html{scroll-behavior:smooth}, which would animate this
         restore (jump to top, then scroll back). Force instant scrolling for
         this one synchronous restore, then put the previous value back. */
      var prevHtmlSB = html.style.scrollBehavior;
      var prevBodySB = b.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      b.style.scrollBehavior = 'auto';
      b.style.position = '';
      b.style.top = '';
      b.style.left = '';
      b.style.right = '';
      b.style.width = '';
      b.style.overflow = '';
      b.style.paddingRight = '';
      window.scrollTo(0, y);
      html.style.scrollBehavior = prevHtmlSB;
      b.style.scrollBehavior = prevBodySB;
    },

    open: function (id, data, type) {
      var overlay = document.getElementById(id);
      var panel   = overlay && overlay.querySelector('.eg-modal-panel');
      if (!overlay || !panel) return;

      /* Focus management: on a FRESH open (nothing else open yet) remember the
         trigger so focus can be restored on close. Skipped during nav swaps and
         benefit -> ingredient chaining, where a modal is already open. */
      if (!document.querySelector('.eg-modal-overlay.is-open')) {
        var _ae = document.activeElement;
        this._prevFocus = (_ae && _ae !== document.body && typeof _ae.focus === 'function') ? _ae : this._triggerEl;
      }

      /* Clean up any listeners left over from a previous open on this overlay
         (e.g. when chaining from a "Pairs Well With" chip without closing). */
      if (overlay._egbd) { overlay.removeEventListener('click', overlay._egbd); overlay._egbd = null; }
      if (this._kb)       { document.removeEventListener('keydown', this._kb); this._kb = null; }

      /* Seamlessly replace any other open modal (e.g. benefit → ingredient).
         Keep the body scroll-lock in place — we re-apply it below. */
      var others = document.querySelectorAll('.eg-modal-overlay.is-open');
      for (var o = 0; o < others.length; o++) {
        if (others[o] !== overlay) {
          others[o].classList.remove('is-open');
          if (others[o]._egbd) { others[o].removeEventListener('click', others[o]._egbd); others[o]._egbd = null; }
        }
      }

      /* Render */
      if      (type === 'molecule')   panel.innerHTML = moleculeHTML(data);
      else if (type === 'benefit')    panel.innerHTML = benefitHTML(data);
      else if (type === 'science')    panel.innerHTML = scienceHTML(data);
      else if (type === 'ingredient') panel.innerHTML = ingredientHTML(data);

      /* Non-ingredient modals carry no prev/next context */
      if (type !== 'ingredient') this._nav = null;

      /* Benefit popups: assign a per-benefit accent (color psychology) so each
         reads as its own theme through the shared --mc token. */
      if (type === 'benefit' && data && !data.color) {
        data.color = BENEFIT_COLORS[data.name] || null;
      }

      /* Color token — drives WIIFM accent and ambient glow */
      if (data && data.color) {
        panel.style.setProperty('--mc', data.color);
        if (type === 'molecule' || type === 'ingredient') {
          panel.style.boxShadow =
            '0 0 52px ' + hexToRgba(data.color, 0.09) +
            ', 0 24px 64px rgba(0,0,0,0.72)';
        }
      }
      if (data && data.borderColor && type === 'science') {
        panel.style.setProperty('--mc', data.borderColor);
      }

      /* Close button */
      var closeBtn = panel.querySelector('.egm-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () { window.EGModals.close(id); });
      }

      /* "Pairs Well With" chips → chain to that ingredient's card in place */
      var pairChips = panel.querySelectorAll('.egk-pair-chip');
      for (var i = 0; i < pairChips.length; i++) {
        pairChips[i].addEventListener('click', function () {
          window.EGModals.openIngredient(this.getAttribute('data-ing-key'));
        });
      }

      /* Ingredient prev/next: arrow clicks, fade-in swap, swipe (Task 1 + 2) */
      if (type === 'ingredient') {
        var prevB = panel.querySelector('.egk-nav-prev');
        var nextB = panel.querySelector('.egk-nav-next');
        if (prevB) prevB.addEventListener('click', function (e) { e.stopPropagation(); window.EGModals.navIngredient(-1); });
        if (nextB) nextB.addEventListener('click', function (e) { e.stopPropagation(); window.EGModals.navIngredient(1); });
        var grid = panel.querySelector('.egk-grid');
        if (grid) {
          grid.classList.add('egk-enter');
          requestAnimationFrame(function () { requestAnimationFrame(function () { grid.classList.remove('egk-enter'); }); });
        }
        if (!panel._egSwipeBound) {
          panel._egSwipeBound = true;
          var sx = 0, sy = 0, tracking = false;
          panel.addEventListener('touchstart', function (e) {
            if (e.touches.length === 1) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true; }
          }, { passive: true });
          panel.addEventListener('touchend', function (e) {
            if (!tracking) return;
            tracking = false;
            var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
              window.EGModals.navIngredient(dx < 0 ? 1 : -1);
            }
          }, { passive: true });
        }
      }

      /* Backdrop click */
      function onBd(e) { if (e.target === overlay) window.EGModals.close(id); }
      overlay._egbd = onBd;
      overlay.addEventListener('click', onBd);

      /* Keyboard: Esc closes; left/right navigate ingredients when nav is active */
      this._kb = function (e) {
        if (e.key === 'Escape') { window.EGModals.close(id); return; }
        if (e.key === 'Tab') {
          var ov = document.getElementById(id);
          var pnl = ov && ov.querySelector('.eg-modal-panel');
          if (!pnl) return;
          var f = egFocusable(pnl);
          if (!f.length) { e.preventDefault(); return; }
          var first = f[0], last = f[f.length - 1], act = document.activeElement;
          if (!pnl.contains(act)) { e.preventDefault(); first.focus({ preventScroll: true }); return; }
          if (e.shiftKey && act === first) { e.preventDefault(); last.focus({ preventScroll: true }); }
          else if (!e.shiftKey && act === last) { e.preventDefault(); first.focus({ preventScroll: true }); }
          return;
        }
        if (id === 'eg-modal-ingredient' && window.EGModals._nav && window.EGModals._nav.list.length > 1) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); window.EGModals.navIngredient(-1); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); window.EGModals.navIngredient(1); }
        }
      };
      document.addEventListener('keydown', this._kb);

      /* Show */
      overlay.classList.add('is-open');
      this._lockScroll();

      /* Move focus into the dialog (the close button) if it isn't already inside.
         preventScroll keeps the scroll-lock position and avoids any jump. */
      var _cbtn = panel.querySelector('.egm-close');
      if (_cbtn && !panel.contains(document.activeElement)) {
        _cbtn.focus({ preventScroll: true });
      }
    },

    /* Resolve an ingredient key + optional product context into a Knowledge
       Card and open it. Used by homepage chips and by chained pair chips. */
    openIngredient: function (key, ctx) {
      var store = window.EG_INGREDIENTS || {};
      var data  = store[key];
      if (!data && window.EGMolecules && window.EGMolecules.cannabinoidDetails) {
        data = window.EGMolecules.cannabinoidDetails[key];
      }
      if (!data) return;
      ctx = ctx || {};

      /* Establish the prev/next navigation list (Task 1) */
      if (ctx._nav) {
        this._nav = ctx._nav;                              // arrow / keyboard / swipe step
      } else if (this._pendingNav && this._pendingNav.list.length > 1) {
        var pn = this._pendingNav, fi = navIndexOf(pn.list, key);
        this._nav = { list: pn.list, idx: fi >= 0 ? fi : pn.idx };
      } else if (this._nav && this._nav.list.length > 1 && navIndexOf(this._nav.list, key) >= 0) {
        this._nav.idx = navIndexOf(this._nav.list, key);   // pair-chip jump within same list
      } else {
        this._nav = null;                                  // no group -> single card, no arrows
      }
      this._pendingNav = null;
      var hasNav = !!(this._nav && this._nav.list.length > 1);

      var pairs = ctx.pairs || data.pairsWith || [];
      if (typeof pairs === 'string') pairs = pairs.split('|');

      this.open('eg-modal-ingredient', {
        name:       egCleanName(ctx.display || data.display || key),
        category:   data.category || 'Ingredient',
        summary:    data.summary || '',
        color:      data.color || '#60a5fa',
        imageUrl:   data.imageUrl || null,
        imageAlt:   data.imageAlt || key,
        imagePosition: data.imagePosition || '',
        imageScale:    data.imageScale || '',
        whatIsIt:   data.description || '',
        why:        ctx.why || data.why || '',
        wiifm:      data.wiifm || '',
        pairs:      pairs,
        isMolecule: (data.category === 'Cannabinoid'),
        _hasNav:    hasNav
      }, 'ingredient');
    },

    /* Step to the previous (-1) or next (+1) ingredient in the active list, looping. */
    navIngredient: function (dir) {
      var nav = this._nav;
      if (!nav || nav.list.length < 2) return;
      var n = nav.list.length;
      var i = (nav.idx + dir + n) % n;
      var it = nav.list[i];
      this.openIngredient(it.key, {
        display: it.display, why: it.why, pairs: it.pairs,
        _nav: { list: nav.list, idx: i }
      });
    },

    close: function (id) {
      var overlay = id
        ? document.getElementById(id)
        : document.querySelector('.eg-modal-overlay.is-open');
      if (!overlay) return;
      overlay.classList.remove('is-open');
      this._unlockScroll();
      if (overlay._egbd) { overlay.removeEventListener('click', overlay._egbd); overlay._egbd = null; }
      if (this._kb)       { document.removeEventListener('keydown', this._kb); this._kb = null; }

      /* Restore focus to the element that opened the modal, if it still exists. */
      var _prev = this._prevFocus;
      this._prevFocus = null;
      if (_prev && document.contains(_prev) && typeof _prev.focus === 'function') {
        _prev.focus({ preventScroll: true });
      }
    }
  };

  /* ── Ingredient trigger groups -> prev/next navigation list ─────────
     A capture-phase click listener records the ordered sibling ingredient
     triggers around whatever the user clicked, so openIngredient can offer
     prev/next through that product's list without editing any section file. */
  var TRIG_SEL =
    '.eg-ingredient-chip[data-ingredient-key],' +
    '.rm-ing-card[data-key],.ao-ing-card[data-key],.pg-ing-card[data-key]';

  function navIndexOf(list, key) {
    for (var i = 0; i < list.length; i++) { if (list[i].key === key) return i; }
    return -1;
  }

  function trigItem(el) {
    var key = el.getAttribute('data-ingredient-key') || el.getAttribute('data-key');
    if (!key) return null;
    var display = el.getAttribute('data-ingredient-display');
    if (!display) {
      var nm = el.querySelector('.rm-ing-card__name,.ao-ing-card__name,.pg-ing-card__name');
      display = nm ? nm.textContent.trim() : '';
    }
    return {
      key: key,
      display: display || '',
      why: el.getAttribute('data-why') || '',
      pairs: el.getAttribute('data-pairs') || ''
    };
  }

  document.addEventListener('click', function (e) {
    var trig = e.target && e.target.closest ? e.target.closest(TRIG_SEL) : null;
    if (!trig || !window.EGModals) return;
    var group = trig.parentElement
      ? Array.prototype.slice.call(trig.parentElement.querySelectorAll(TRIG_SEL))
      : [trig];
    var list = [], idx = 0;
    for (var i = 0; i < group.length; i++) {
      var it = trigItem(group[i]);
      if (!it) continue;
      if (group[i] === trig) idx = list.length;
      list.push(it);
    }
    window.EGModals._pendingNav = list.length ? { list: list, idx: idx } : null;
  }, true);

  /* Record the last pressed trigger so focus can be restored to it after a modal
     closes — covers touch / Safari where activating a button doesn't focus it. */
  document.addEventListener('pointerdown', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('button, a, [tabindex]') : null;
    if (t && window.EGModals) window.EGModals._triggerEl = t;
  }, true);

})();
